import './main.css'

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.config.productionTip = false

Vue.use(VueRouter)

const avatar = () => import(/* webpackChunkName: "avatar" */ './components/avatar/avatar.vue')
const ball = () => import(/* webpackChunkName: "ball" */ './components/ball/ball.vue')
const bucket = () => import(/* webpackChunkName: "bucket" */ './components/bucket/bucket.vue')
const ceci = () => import(/* webpackChunkName: "ceci" */ './components/ceci/ceci.vue') // 23.06.2008 20:24:16
const channel15 = () => import(/* webpackChunkName: "channel15" */ './components/channel15/channel15.vue')
const designcoding = () => import(/* webpackChunkName: "designcoding" */ './components/designcoding/designcoding.vue') // 31.03.2008 19:07:37
const her = () => import(/* webpackChunkName: "her" */ './components/her/her.vue')
const ierpp = () => import(/* webpackChunkName: "ierpp" */ './components/ierpp/ierpp.vue')
const ikketoft = () => import(/* webpackChunkName: "ikketoft" */ './components/ikketoft/ikketoft.vue')
const innovative = () => import(/* webpackChunkName: "innovative" */ './components/innovative/innovative.vue')
const loff = () => import(/* webpackChunkName: "loff" */ './components/loff/loff.vue')
const ndb = () => import(/* webpackChunkName: "ndb" */ './components/ndb/ndb.vue')
const nese = () => import(/* webpackChunkName: "nese" */ './components/nese/nese.vue')
const norschach = () => import(/* webpackChunkName: "norschach" */ './components/norschach/norschach.vue')
const nosebrother = () => import(/* webpackChunkName: "nosebrother" */ './components/nosebrother/nosebrother.vue')
const podcatting = () => import(/* webpackChunkName: "podcatting" */ './components/podcatting/podcatting.vue')
const price = () => import(/* webpackChunkName: "price" */ './components/price/price.vue') // 16.04.2007 19:33
const qrherrmathisen = () => import(/* webpackChunkName: "qrherrmathisen" */ './components/qrherrmathisen/qrherrmathisen.vue') // 25.07.2009 16:02:55
//const qrnesebror = () => import(/* webpackChunkName: "qrnesebror" */ './components/qrnesebror/qrnesebror.vue') // 29.11.2008 13:52:35
const red = () => import(/* webpackChunkName: "red" */ './components/red/red.vue')
//const salg = () => import(/* webpackChunkName: "salg" */ './components/salg/salg.vue') // 24.05.2007 21:16
const sans = () => import(/* webpackChunkName: "sans" */ './components/sans/sans.vue')
const shining = () => import(/* webpackChunkName: "shining" */ './components/shining/shining.vue')
const shush = () => import(/* webpackChunkName: "shush" */ './components/shush/shush.vue') // 18.11.2007 16:52
const signon = () => import(/* webpackChunkName: "signon" */ './components/signon/signon.vue')
const spesifisk = () => import(/* webpackChunkName: "spesifisk" */ './components/spesifisk/spesifisk.vue')
const tditf = () => import(/* webpackChunkName: "tditf" */ './components/tditf/tditf.vue')
const utenkluss = () => import(/* webpackChunkName: "utenkluss" */ './components/utenkluss/utenkluss.vue')
const vlathugra = () => import(/* webpackChunkName: "vlathugra" */ './components/vlathugra/vlathugra.vue') // 29.02.2008 15:18:15

const routes = [
  {
    path: '/', redirect: () => {
      const idx = Math.floor(Math.random() * routes.length)
      return routes[idx].path
    }
  },
  { path: '/avatar', component: avatar },
  { path: '/ball', component: ball },
  { path: '/bucket', component: bucket },
  { path: '/ceci', component: ceci },
  { path: '/channel15', component: channel15 },
  { path: '/designcoding', component: designcoding },
  { path: '/her', component: her },
  { path: '/ierpp', component: ierpp },
  { path: '/ikketoft', component: ikketoft },
  { path: '/innovative', component: innovative },
  { path: '/loff', component: loff },
  { path: '/ndb', component: ndb },
  { path: '/nese', component: nese },
  { path: '/norschach', component: norschach },
  { path: '/nosebrother', component: nosebrother },
  { path: '/podcatting', component: podcatting },
  { path: '/price', component: price },
  { path: '/qrherrmathisen', component: qrherrmathisen },
  //{ path: '/qrnesebror', component: qrnesebror },
  { path: '/red', component: red },
  //{ path: '/salg', component: salg },
  { path: '/sans', component: sans },
  { path: '/shining', component: shining },
  { path: '/shush', component: shush },
  { path: '/signon', component: signon },
  { path: '/spesifisk', component: spesifisk },
  { path: '/tditf', component: tditf },
  { path: '/utenkluss', component: utenkluss },
  { path: '/vlathugra', component: vlathugra },
]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes,
})

new Vue({
  router,
  template: `
    <div id="app">
      <router-view class="view"></router-view>
    </div>
  `,
}).$mount('#app')
